export default "__VITE_ASSET__BJE0RdRU__"